import * as _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import { ActionCd } from '@xpo-ltl/sdk-common';
import { Note } from '@xpo-ltl/sdk-linehaulpayform';
import { addNoteAction, deleteNoteAction, updateNoteAction } from './notes.actions';
import { AppStateUtils } from '../app-state.utils';

export const initialState: Note[] = [];

export const NotesReducer = createReducer(
  initialState,
  on(addNoteAction, (state, { note }) => {
    const newNote = _.cloneDeep(note) as Note;
    newNote.listActionCd = ActionCd.ADD;
    return [...state, newNote];
  }),
  on(updateNoteAction, (state, { note }) => {
    const noteIndex = AppStateUtils.findNoteIndexInState(state, note.noteSequenceNbr);

    if (state[noteIndex].listActionCd !== ActionCd.ADD) {
      state[noteIndex].listActionCd = ActionCd.UPDATE;
    }
    state[noteIndex].comments = note.comments;

    return [...state];
  }),
  on(deleteNoteAction, (state, { noteSequenceNbr }) => {
    const existingNote = AppStateUtils.findNoteInState(state, noteSequenceNbr) as Note;
    if (existingNote) {
      if (existingNote.listActionCd === ActionCd.ADD) {
        // remove newly added note from list
        _.pull(state, existingNote);
      } else {
        // mark exisiting note as deleted
        existingNote.listActionCd = ActionCd.DELETE;
      }
      return [...state];
    } else {
      // note didn't exist in this Payform, so nothing to do
      return state;
    }
  })
);
